var render, staticRenderFns
import script from "./scenicAreasPageSetDetail.vue?vue&type=script&lang=js"
export * from "./scenicAreasPageSetDetail.vue?vue&type=script&lang=js"
import style0 from "./scenicAreasPageSetDetail.vue?vue&type=style&index=0&id=cea12862&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea12862",
  null
  
)

export default component.exports